/**
 * @generated SignedSource<<fe86221522c0d179653e3410c3f50b72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutinePositivePercentageScreenQuery$variables = {
  widgetId: string;
};
export type WidgetRoutinePositivePercentageScreenQuery$data = {
  readonly widgetRoutinePositivePercentage: {
    readonly id: string;
    readonly routines: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutinePositivePercentageScreen_routine">;
    }>;
    readonly title: string;
  } | null;
};
export type WidgetRoutinePositivePercentageScreenQuery = {
  response: WidgetRoutinePositivePercentageScreenQuery$data;
  variables: WidgetRoutinePositivePercentageScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "widgetId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "widgetId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetRoutinePositivePercentageScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetRoutinePositivePercentage",
        "kind": "LinkedField",
        "name": "widgetRoutinePositivePercentage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routines",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetRoutinePositivePercentageScreen_routine"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WidgetRoutinePositivePercentageScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "WidgetRoutinePositivePercentage",
        "kind": "LinkedField",
        "name": "widgetRoutinePositivePercentage",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Routine",
            "kind": "LinkedField",
            "name": "routines",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "inProgressOccasion",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "lastCompletedOccasion",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "percentage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "71f661481458899ce99824eb4c6db0fd",
    "id": null,
    "metadata": {},
    "name": "WidgetRoutinePositivePercentageScreenQuery",
    "operationKind": "query",
    "text": "query WidgetRoutinePositivePercentageScreenQuery(\n  $widgetId: ID!\n) {\n  widgetRoutinePositivePercentage(id: $widgetId) {\n    id\n    title\n    routines {\n      id\n      ...WidgetRoutinePositivePercentageScreen_routine\n    }\n  }\n}\n\nfragment WidgetRoutinePositivePercentageScreen_routine on Routine {\n  id\n  title\n  inProgressOccasion {\n    id\n    sequenceNumber\n  }\n  lastCompletedOccasion {\n    id\n    sequenceNumber\n    percentage\n  }\n}\n"
  }
};
})();

(node as any).hash = "963ceaf5a1286d16996b578b352ebd45";

export default node;
